<div class="flex gap-[30px] flex-wrap place-content-center max-w-[1680px] mx-auto">
    @for (ship of ships; track $index) {
    <div class="rounded-[10px] w-[540px] p-2.5 bg-white bg-opacity-70 backdrop-blur-sm">
        <div class="w-[520px] h-[250px] rounded-[12px] bg-cover bg-center bg-no-repeat" [style]="'background-image:url(' + baseUrl + '/image/' + ship.images[0].url + ')'"></div>
        <div class="flex items-center mt-2.5">
            <div class="w-[calc(100%-68px)]">
                <div class="text-secondary text-[28px] font-medium">{{ship.name}}</div>
                <div class="text-secondary text-[18px]">{{ship.description}}</div>
            </div>
            <svg class="ml-auto cursor-pointer" width="68" height="68" viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_d_6_611)">
                    <rect x="8" y="6" width="48" height="48" rx="24" fill="white" fill-opacity="0.1"
                        shape-rendering="crispEdges" />
                    <rect x="8.5" y="6.5" width="47" height="47" rx="23.5" stroke="#192146"
                        shape-rendering="crispEdges" />
                    <path d="M32.5617 23.2489L39.3127 29.9999L32.5617 36.7509" stroke="#192146" stroke-width="2"
                        stroke-miterlimit="10" stroke-linecap="square" />
                    <path d="M38.3761 30.0004H24.6866" stroke="#192146" stroke-width="2" stroke-miterlimit="10"
                        stroke-linecap="square" />
                </g>
                <defs>
                    <filter id="filter0_d_6_611" x="0" y="0" width="68" height="68" filterUnits="userSpaceOnUse"
                        color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha" />
                        <feOffset dx="2" dy="4" />
                        <feGaussianBlur stdDeviation="5" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6_611" />
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_6_611" result="shape" />
                    </filter>
                </defs>
            </svg>

        </div>
    </div>
    }
</div>